import { Injectable } from '@angular/core';
import { HighRiskCountries, IsoCountries } from '@zero/shared/util-models';

@Injectable({
  providedIn: 'root',
})
export class CountriesService {
  public readonly allIsoCountriesEnum = IsoCountries;
  public readonly allIsoCodesSortedByDisplayName: string[];
  public readonly isoCodesDACH = ['DE', 'AT', 'CH'];
  public readonly isoCodesSortedByDisplayName_NoUSA_NoHighRiskCountries: string[];
  public readonly isoCodesSortedByDisplayNameNoUSA: string[];
  public readonly isoCodesSortedByDisplayNameWithoutBlockedCountries: string[];
  public readonly isoCodesSortedByDisplayName_NoHighRiskCountries: string[];
  public readonly isoCodesSortedByDisplayName_EU_DACH: string[];
  public readonly isoCodesSortedByDisplayName_EU_WithoutBlockedCountries: string[];
  public readonly isoCodesEU = [
    'AT',
    'BE',
    'BG',
    'CY',
    'CZ',
    'DE',
    'DK',
    'EE',
    'ES',
    'FI',
    'FR',
    'GR',
    'HR',
    'HU',
    'IE',
    'IT',
    'XK',
    'LT',
    'LU',
    'LV',
    'MT',
    'NL',
    'PL',
    'PT',
    'RO',
    'SE',
    'SI',
    'SK',
  ];
  public readonly isoCodesBlockedCountries = ['CH', 'CY', 'BG', 'RO', 'HU', 'MT', 'XK'];

  constructor() {
    this.allIsoCodesSortedByDisplayName = this.isoCodesDACH.concat(
      Object.entries(IsoCountries)
        .sort((a, b) => {
          if (a[1] < b[1]) {
            return -1;
          } else if (a[1] > b[1]) {
            return 1;
          } else {
            return 0;
          }
        })
        .map((c) => c[0])
        .filter((c) => this.isoCodesDACH.indexOf(c) == -1),
    );

    this.isoCodesSortedByDisplayNameNoUSA = this.allIsoCodesSortedByDisplayName.filter((c) => c !== 'US');

    this.isoCodesSortedByDisplayName_NoUSA_NoHighRiskCountries = this.isoCodesSortedByDisplayNameNoUSA.filter((c) => !HighRiskCountries[c]);
    this.isoCodesSortedByDisplayName_NoHighRiskCountries = this.allIsoCodesSortedByDisplayName.filter((c) => !HighRiskCountries[c]);

    const eu_dach_codes = [];
    this.isoCodesDACH.forEach((c) => (eu_dach_codes[c] = true));
    this.isoCodesEU.forEach((c) => (eu_dach_codes[c] = true));
    this.isoCodesSortedByDisplayName_EU_DACH = this.allIsoCodesSortedByDisplayName.filter((c) => eu_dach_codes[c]);

    this.isoCodesSortedByDisplayNameWithoutBlockedCountries = this.allIsoCodesSortedByDisplayName.filter(
      (c) => !this.isoCodesBlockedCountries.includes(c),
    );
    this.isoCodesSortedByDisplayName_EU_WithoutBlockedCountries = this.isoCodesSortedByDisplayName_EU_DACH.filter(
      (c) => !this.isoCodesBlockedCountries.includes(c),
    );
  }
}
